import { render, staticRenderFns } from "./disbursementRepaymentMonthly.vue?vue&type=template&id=53ca2424&"
import script from "./disbursementRepaymentMonthly.vue?vue&type=script&lang=js&"
export * from "./disbursementRepaymentMonthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports